import { createConsumer } from '@rails/actioncable'

type CableConsumer = ReturnType<typeof createConsumer>

let consumer: CableConsumer | null = null

export function getCable(): CableConsumer {
  if (!consumer) {
    consumer = createConsumer()
  }

  return consumer
}
